export type PlansLanguage = 'ja' | 'en';

const normalizeLanguage = (language: string): PlansLanguage | null => {
    const primaryLanguage = language.trim().toLowerCase().split(/[-_]/)[0];

    return primaryLanguage === 'ja' || primaryLanguage === 'en'
        ? primaryLanguage
        : null;
};

/**
 * ブラウザで優先されている対応言語を返す。
 * 対応言語がない、またはブラウザ情報を取得できない場合は英語にする。
 */
export const resolvePlansLanguage = (
    languages: readonly string[] | undefined,
    language: string | undefined,
): PlansLanguage => {
    const browserLanguages = languages?.length ? languages : language ? [language] : [];

    for (const browserLanguage of browserLanguages) {
        const supportedLanguage = normalizeLanguage(browserLanguage);
        if (supportedLanguage) {
            return supportedLanguage;
        }
    }

    return 'en';
};
